// Imports
import Cookies from 'universal-cookie';

/**
 * Read auth cookie and return in
 */
export function getAuthCookie() {
  const cookies = new Cookies();
  const cookieValue = cookies.get('vendor-token');
  if (cookieValue) return cookieValue;
  const localStorageValue = localStorage.getItem('vendor-token');
  return localStorageValue;
}

/**
 * Save authentication cookie
 * @param token 
 */
export function saveAuthCookie(token: string) {
  const cookies = new Cookies();
  cookies.set('vendor-token', token, { path: '/' });
  localStorage.setItem('vendor-token', token);
}